module.exports = require('./click_to_pause')



/** WEBPACK FOOTER **
 ** ./src/plugins/click_to_pause/index.js
 **/